import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import { useEffect } from "react";

// Inline scroll reset component
function ResetScrollOnRouteChange() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Helper to set or create a meta tag
function setMeta(selector, attribute, value) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [attr, val] = selector.replace(/[[\]']/g, "").split("=");
    el.setAttribute(attr, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attribute, value);
}

export default function App() {
  useEffect(() => {
    const title = "Jedidah Nzila | Full Stack Developer";
    const description =
      "Full-stack developer specializing in building real-world, production-ready systems that are fast, scalable, and user-focused. Based in Nairobi, Kenya, I develop end-to-en web applications using modern technologies to turn ideas into working digital products.";
    const url = "https://jedidahnzila.site";
    const image = "https://jedidahnzila.site/og-image.png";

    // --- Basic ---
    document.title = title;
    setMeta("meta[name='description']", "content", description);
    setMeta("meta[name='author']", "content", "Jedidah Nzila");
    setMeta(
      "meta[name='keywords']",
      "content",
      "Jedidah Nzila, Full Stack Developer, Web Developer, Nairobi, Kenya, React, PHP,Laravel,Nextjs,Redux,Frontend developer,Backend Developer, Software Engineer"
    );

    // --- Open Graph (Facebook, LinkedIn, WhatsApp, Google) ---
    setMeta("meta[property='og:type']", "content", "website");
    setMeta("meta[property='og:title']", "content", title);
    setMeta("meta[property='og:description']", "content", description);
    setMeta("meta[property='og:url']", "content", url);
    setMeta("meta[property='og:image']", "content", image);
    setMeta("meta[property='og:site_name']", "content", "Jedidah Nzila");
    setMeta("meta[property='og:locale']", "content", "en_KE");

    // --- Twitter Card ---
    setMeta("meta[name='twitter:card']", "content", "summary_large_image");
    setMeta("meta[name='twitter:title']", "content", title);
    setMeta("meta[name='twitter:description']", "content", description);
    setMeta("meta[name='twitter:image']", "content", image);
    // setMeta("meta[name='twitter:site']", "content", "@yourhandle"); // Optional

    // --- Canonical URL ---
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative">
      <ResetScrollOnRouteChange />
      <Navbar />
      <main className="flex-grow pt-16 relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
